import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaintroller = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M9 11.75v-2.9a.1.1 0 0 1 .1-.1h8.05a.1.1 0 0 0 .1-.1V4.1a.1.1 0 0 0-.1-.1h-1.9m-12 2.25h11.5a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5H3.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5Zm4.75 12h2a.25.25 0 0 0 .25-.25v-6a.25.25 0 0 0-.25-.25H8a.25.25 0 0 0-.25.25v6c0 .138.112.25.25.25Z"
	})]
});
const ForwardRef = forwardRef(SvgPaintroller);
export { ForwardRef as ReactComponent };
